import React from 'react';
import SwatchCard from './SwatchCard';

export default function HarmonySection({ harmony, isActive, onToggle }) {
  return (
    <div style={{
      borderBottom: '1px solid rgba(245,240,232,0.07)',
      overflow: 'hidden',
    }}>
      <button
        onClick={onToggle}
        style={{
          width: '100%',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '14px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          color: '#e8eaf0',
          textAlign: 'left',
          transition: 'background 0.2s ease',
        }}
      >
        <div>
          <div style={{
            fontFamily: "'Cinzel', serif",
            fontSize: 11,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            opacity: 0.9,
          }}>
            {harmony.label}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ display: 'flex', gap: 4 }}>
            {harmony.swatches.slice(0, 4).map((sw, i) => (
              <div key={i} style={{
                width: 16,
                height: 16,
                borderRadius: 2,
                background: sw.hex,
                border: '1px solid rgba(255,255,255,0.1)',
              }} />
            ))}
          </div>
          <span style={{
            fontSize: 14,
            opacity: 0.4,
            transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            display: 'inline-block',
          }}>›</span>
        </div>
      </button>

      <div style={{
        maxHeight: isActive ? 500 : 0,
        overflow: 'hidden',
        transition: 'max-height 0.3s ease',
      }}>
        <div style={{ padding: '0 20px 18px' }}>
          <p style={{
            fontFamily: "'Crimson Pro', serif",
            fontStyle: 'normal',
            fontSize: 13,
            color: 'rgba(245,240,232,0.85)',
            margin: '0 0 14px',
            lineHeight: 1.6,
          }}>
            {harmony.description}
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {harmony.swatches.map((sw, i) => (
              <SwatchCard key={i} swatch={sw} size="md" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
